import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "top-navigation" }
const _hoisted_2 = { class: "topnav-company-name" }
const _hoisted_3 = {
  class: "navigation-box",
  style: {"float":"right"}
}
const _hoisted_4 = { class: "language" }
const _hoisted_5 = { class: "badgets" }
const _hoisted_6 = { class: "user-info" }

import { onMounted, ref } from "vue";
import LanguageDropdown from "@/components/controller/LanguageDropdown.vue";
import UserInfoDropdown from "@/components/controller/UserInfoDropdown.vue";
import { useI18n } from "vue-i18n";
import router from "@/router";

// 模组注入部分
interface LinkItem {
  value: string;
  link: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TopNavigation',
  setup(__props) {

const { t } = useI18n();
// 搜索框部分
const inputState = ref("");

const links = ref<LinkItem[]>([]);

const loadAll = () => {
  return [
    { value: t("r.overall"), link: "/overall" },
    { value: t("r.organization_list"), link: "/organization_list" },
    { value: t("r.ship_list"), link: "/ship_list" },
    { value: t("r.create_upgrade_plan"), link: "/create_upgrade_plan" },
    { value: t("r.upgrade_list"), link: "/upgrade_list" },
  ];
};

let timeout: ReturnType<typeof setTimeout>;
/* eslint-disable @typescript-eslint/no-explicit-any */
const querySearchAsync = (queryString: string, cb: (arg: any) => void) => {
  const results = queryString
    ? links.value.filter(createFilter(queryString))
    : links.value;

  clearTimeout(timeout);
  timeout = setTimeout(() => {
    cb(results);
  }, 3000 * Math.random());
};
const createFilter = (queryString: string) => {
  return (restaurant: LinkItem) => {
    return (
      restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
    );
  };
};

const handleSelect = (item: Record<string, any>) => {
  router.replace({ path: item.link });
};

onMounted(() => {
  // 搜索栏链接加载
  links.value = loadAll();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_badge = _resolveComponent("el-badge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("m.racernManagement")), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(LanguageDropdown)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_badge, {
          value: 0,
          class: "item",
          type: "primary",
          "show-zero": false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_popover, {
              placement: "bottom",
              width: 200,
              "popper-style": "box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 20px;"
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_button, {
                  plain: "",
                  type: "primary"
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("通知", -1)
                  ]))]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createElementVNode("div", { style: {"color":"grey"} }, "没有通知", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_badge, {
          value: 0,
          class: "item",
          type: "warning",
          "show-zero": false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_popover, {
              placement: "bottom",
              width: 200,
              "popper-style": "box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 20px;"
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_button, {
                  plain: "",
                  type: "warning"
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode("警告", -1)
                  ]))]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createElementVNode("div", { style: {"color":"grey"} }, "没有警告", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(UserInfoDropdown)
      ])
    ])
  ]))
}
}

})